<div class="ipm-dsh">
    <div class="ipm-dsh-top">
        <span class="ipm-dsh-lamp">🪔</span>
        <h2 class="ipm-dsh-title"><span class="ipm-dsh-brand">Beat22</span> <span class="ipm-dsh-sale">Diwali</span> <span class="ipm-dsh-brand">Sale</span></h2>
    </div>
    <!-- sale countdown and sale dates on one line; the countdown says "Sale starts in" before the sale, "Sale ends in" during it -->
    <div class="ipm-dsh-meta" *ngIf="startAt && endAt">
        <ipm-sale-countdown class="ipm-dsh-countdown" appearance="inline" [startAt]="startAt" [endAt]="endAt"></ipm-sale-countdown>
        <span class="ipm-dsh-dates">
            <span class="ipm-dsh-date">{{startAt | date : 'd MMM'}}</span>
            <i class="pi pi-arrow-right ipm-dsh-arrow"></i>
            <span class="ipm-dsh-date">{{endAt | date : 'd MMM'}}</span>
        </span>
    </div>
    <p class="ipm-dsh-tagline" *ngIf="isTagShown">{{tagline}}</p>
    <div class="ipm-dsh-shimmer"></div>
</div>
